<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48.526"
    height="50.695"
    viewBox="0 0 48.526 50.695"
  >
    <path
      d="M21.757,8.276a7.065,7.065,0,0,1,12.478,0l18.273,34.4a7.065,7.065,0,0,1-6.239,10.38H9.724a7.065,7.065,0,0,1-6.239-10.38Z"
      transform="translate(53.052 -2.649) rotate(90)"
    />
  </svg>
</template>
<script>
export default {
  name: 'RecordPlayIcon',
};
</script>
